/* eslint-disable no-useless-constructor */
/* global DeferredMedia */

if (!customElements.get('product-model')) {
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this)
        }
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  }

  customElements.define('product-model', ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="product-json-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
document.addEventListener("DOMContentLoaded", function () {
  const priceBlock = document.querySelector(".price-block");
  if (!priceBlock) return;

  const currentPriceEl = priceBlock.querySelector(".price-current");
  const comparePriceEl = priceBlock.querySelector(".price-compare");
  const saveEl = priceBlock.querySelector(".price-save");

  const productSelect = document.querySelector("form[action*='/cart/add'] select[name='id']");
  if (!productSelect) return;

  productSelect.addEventListener("change", function () {
    const selectedVariantId = this.value;
    if (!window?.Shopify?.product?.variants) return;

    const variant = Shopify.product.variants.find(v => v.id == selectedVariantId);
    if (!variant) return;

    const formatMoney = (cents) => {
      return Shopify.formatMoney(cents, Shopify.currency.active_format || "€{{amount}}");
    };

    currentPriceEl.innerHTML = formatMoney(variant.price);

    if (variant.compare_at_price > variant.price) {
      comparePriceEl.style.display = "inline";
      saveEl.style.display = "inline";

      comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
      saveEl.innerHTML = `Save ${formatMoney(variant.compare_at_price - variant.price)}`;
    } else {
      comparePriceEl.style.display = "none";
      saveEl.style.display = "none";
    }
  });
});

